import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface VendorContactRatingsTableProps {
}

export const VendorContactRatingsTable: React.FC<VendorContactRatingsTableProps> = () => {

    const vendorContactsState = useAppSelector(state => state.vendorContacts);

    return (
        <table className="data">
            <thead>
            <tr>
                <th>Checker</th>
                <th>Hinnang</th>
                <th>Kommentaar</th>
                <th className="right w150"></th>
            </tr>
            </thead>
            <tbody>
            {vendorContactsState.ratings?.map(row => {

                const rowClass = (row.rating < 5) ? 'reclamation' : '';

                return (
                    <tr className={rowClass}>
                        <td>
                            {row.name}
                        </td>
                        <td>
                            {row.rating}
                        </td>
                        <td>
                            {row.comment}
                        </td>
                        <td className="action">
                            <Link to={`/orders/${row.order_id}/modify`}>Vedu</Link>
                        </td>
                    </tr>
                )
            })}
            </tbody>
        </table>
    );

}